export default __webpack_public_path__ + "static/media/book_2.6646cdf1.svg";